module.exports = __webpack_public_path__ + "static/media/js.697a2639.svg";